export default __webpack_public_path__ + "static/media/thirty-minute-walk.c3b4f244.svg";